import { USER_POOL_CLIENT_ID } from './configs';

/** Stores Cognito tokens in localStorage for Amplify */
export const saveCognitoTokens = tokens => {
  const keyPrefix = `CognitoIdentityServiceProvider.${USER_POOL_CLIENT_ID}`;

  const idTokenPayload = JSON.parse(atob(tokens.id_token.split('.')[1]));
  const username = idTokenPayload['cognito:username'] || idTokenPayload.sub;

  localStorage.setItem(`${keyPrefix}.LastAuthUser`, username);
  localStorage.setItem(`${keyPrefix}.${username}.idToken`, tokens.id_token);
  localStorage.setItem(
    `${keyPrefix}.${username}.accessToken`,
    tokens.access_token
  );

  if (tokens.refresh_token) {
    localStorage.setItem(
      `${keyPrefix}.${username}.refreshToken`,
      tokens.refresh_token
    );
  }

  localStorage.setItem(`${keyPrefix}.${username}.clockDrift`, '0');

  console.log('✅ Cognito tokens saved for user:', username);

  return username;
};

/** Exchanges authorization code for tokens via Cognito */
export const exchangeCodeForTokens = async (
  code,
  redirectUri,
  codeVerifier,
  userPoolDomain,
  clientId
) => {
  const tokenEndpoint = `https://${userPoolDomain}/oauth2/token`;

  const body = new URLSearchParams({
    grant_type: 'authorization_code',
    client_id: clientId,
    code,
    redirect_uri: redirectUri,
    code_verifier: codeVerifier,
  });

  console.log('🔄 Exchanging code for tokens...');
  console.log('📍 redirect_uri:', redirectUri);

  const response = await fetch(tokenEndpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: body.toString(),
  });

  if (!response.ok) {
    const errorData = await response.text();
    throw new Error(`Token exchange failed: ${response.status} ${errorData}`);
  }

  const tokens = await response.json();
  console.log('✅ Tokens received');

  return tokens;
};

/** Cleans Cognito tokens from localStorage */
export const clearCognitoTokens = () => {
  const keyPrefix = `CognitoIdentityServiceProvider.${USER_POOL_CLIENT_ID}`;
  const lastAuthUser = localStorage.getItem(`${keyPrefix}.LastAuthUser`);

  if (lastAuthUser) {
    localStorage.removeItem(`${keyPrefix}.${lastAuthUser}.idToken`);
    localStorage.removeItem(`${keyPrefix}.${lastAuthUser}.accessToken`);
    localStorage.removeItem(`${keyPrefix}.${lastAuthUser}.refreshToken`);
    localStorage.removeItem(`${keyPrefix}.${lastAuthUser}.clockDrift`);
    localStorage.removeItem(`${keyPrefix}.LastAuthUser`);

    console.log('🗑️ Cognito tokens cleared');
  }
};
